export const progressLoadingBar = ({
  loadingTime, onUpdate, ...options
}: {
  loadingTime: number,
  onUpdate: (arg: {percentage: number}) => void,
  updateInterval?: number,
}) => {
  const updateInterval = options.updateInterval || 100;
  let elapsed = 0;
  return new Promise<void>((resolve) => {
    const timer = setInterval(() => {
      elapsed += updateInterval;
      onUpdate({ percentage: (elapsed / loadingTime) * 100 });
      if (elapsed >= loadingTime) {
        clearInterval(timer);
        resolve();
      }
    }, updateInterval);
  });
};

export const getRandomLoadingTime = ({ min, max }: { min: number, max: number }) => (
  Math.floor(Math.random() * (max - min)) + min
);
